module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFBAMAAACKv7BmAAAAAXNSR0IB2cksfwAAABtQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlFHiIAAAAAl0Uk5TABMKMwMwKikgWrd5QAAAACFJREFUeJxjYGAUYGBgUDZiYGAJNnVgYDM2LmBoNja2AAAaGQMw8l1kGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/sort-icon.png
// module id = 179
// module chunks = 33